import React from 'react';
// import NewReportsContainer from '../../Containers/ReportsContainer/NewReportsContainer';
const NewReportsContainer = React.lazy(() => import('../../Containers/ReportsContainer/NewReportsContainer'));


const NewReports = (props) => {
	return (
		<NewReportsContainer />
	);
}

export default NewReports;